export default __webpack_public_path__ + "6a87135582202029736f1b76716b2fec.svg";